define('GameDayCore/GDModel/enums/baseball/PitchTypes',{
    FA: "Fastball",
    FF: "4-Seam Fastball",
    FT: "2-Seam Fastball",
    FC: "Cutter",
    FO: "Forkball",
    FS: "Splitter",
    SI: "Sinker",
    SL: "Slider",
    CU: "Curveball",
    KC: "Knuckle Curve",
    SC: "Screwball",
    GY: "Gyroball",
    CH: "Changeup",
    KN: "Knuckleball",
    IN: "Int. Ball",
    PO: "Pitchout",
    UN: "Unknown",
    SN: "Unknown",
    AB: "Auto. Ball",
    AS: "Auto. Strike",
    NP: "No Pitch",
    EP: "Eephus",

    //SPANISH LANGUAGE PITCH TYPES
    FA_ES: "Recta",
    FF_ES: "Recta", //de cuatro costuras",
    FT_ES: "Recta", //de dos costuras",
    FC_ES: "Recta cortada",
    FO_ES: "Tenedor",
    FS_ES: "Recta de dedos separados",
    SI_ES: "Sinker",
    SL_ES: "Slider",
    CU_ES: "Curva",
    KC_ES: "Nudillo-Curva",
    SC_ES: "Tirabuzón",
    GY_ES: "Gyroball",
    CH_ES: "Cambio",
    KN_ES: "Nudillo",
    IN_ES: "Bola Intencional",
    PO_ES: "Bola Franca",
    UN_ES: "Desconocido",
    SN_ES: "Desconocido",
    AB_ES: "Bola Automática",
    AS_ES: "Strike Automático",
    NP_ES: "No Lanzamiento",
    EP_ES: "Globito"
});
